import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const MerchantReturnDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["productreturnproductinfo", "product"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: ["productreturnproductinfo", "description"],
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text) => <p>{text}</p>,
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantReturnDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      ref_number: selectedData !== null ? selectedData.ref_number : "",
    };
    axios
      .get("user/merchant/spec-return-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantReturnDetails();
  }, [getMerchantReturnDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Return Order Details"
      // width={window.innerWidth > 710 ? 710 : "100vw"}
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {displayDetailsPrint && (
                <Typography.Title style={{ marginBottom: 15 }}>
                  Return Products
                </Typography.Title>
              )}
              <Typography
                style={{
                  //  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                Date Created:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    moment(orderDetailsList.data[0].created_at)
                      .utc()
                      .format("LLL")}
                </span>
              </Typography>

              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                  //   marginBottom: 10,
                }}
              >
                Reference #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].ref_number}
                </span>
              </Typography>
              <Typography
                style={{
                  // fontWeight: "bold",
                  fontSize: 14,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                Reason:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready && orderDetailsList.data[0].reason}
                </span>
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.product_id}
            />
          </div>
        </>
      )}
    </Drawer>
  );
};

export default MerchantReturnDetails;
